// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1v4e7","col":"styles_col__36OKN"};